module.exports = "/_next/static/images/39f2e9098a1fcd07cf54713d40fa4e0b-women-xs.png";